import { parseFrontmatter } from "@vortex-os/core";
import type { LintFinding, LintRule } from "../types.js";

export interface RequireFrontmatterOptions {
  /** Frontmatter keys that must be present and non-empty. */
  readonly required: readonly string[];
}

/**
 * Rule that ensures the listed frontmatter keys are present and non-empty.
 * Empty string, null, and undefined values all fail the check; `0`, `false`,
 * and structured values (arrays, objects) pass as long as they exist.
 */
export function requireFrontmatter(options: RequireFrontmatterOptions): LintRule {
  return {
    id: "require-frontmatter",
    description: `Ensure required frontmatter keys are present: ${options.required.join(", ")}`,
    check({ file, content }) {
      const findings: LintFinding[] = [];
      const { frontmatter } = parseFrontmatter<Record<string, unknown>>(content);
      for (const key of options.required) {
        const value = frontmatter[key];
        if (value === undefined || value === null || value === "") {
          findings.push({
            rule: "require-frontmatter",
            severity: "error",
            file,
            message: `Missing required frontmatter key: "${key}"`,
          });
        }
      }
      return findings;
    },
  };
}
